import { configureStore } from "@reduxjs/toolkit";

import tokenSlice from "./slices/token.slice.js";
import productsSlice from "./slices/products.slice.js";
import userDataSlice from "./slices/userData.slice.js";
import actionsSlice from "./slices/actions.slice.js";
import alertsSlice from "./slices/alerts.slice.js";
import appDataSlice from "./slices/appData.slice.js";

const store = configureStore({
  reducer: {
    tokenSlice,
    productsSlice,
    userDataSlice,
    actionsSlice,
    alertsSlice,
    appDataSlice,
  },
});

export default store;
